import { type IHoliday } from "@/interfaces/api/holiday.interface"
import { HolidayRepository } from "@/repositories/holiday-repository"
import { Holiday } from "@/models/holiday.model"
import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller"
import { useHolidayStore } from "@/store/holidays.store"
import { storeToRefs } from "pinia"
import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers"

export class HolidayController extends GenericModelController<
  Holiday,
  IHoliday,
  HolidayRepository
> {
  constructor() {
    const holidayStore = useHolidayStore()
    const { holidays } = storeToRefs(holidayStore)
    const storeFunctionsConfig = {
      collection: holidays
    }

    super(Holiday, storeFunctionsConfig, new HolidayRepository())

    this.socketSynchronizationHandlers = useSocketSynchronizationHandlers(Holiday, holidays)
  }
}
